import React, { Component } from "react";
import styled from "styled-components";

class Member extends Component {
  render() {
    let color;
    if (this.props.points > 75) {
      color = "#F44336";
    } else if (this.props.points > 67.5) {
      color = "#FDD835";
    } else {
      color = "inherit";
    }
    const Number = styled.h3`
      color: ${color};
    `;

    const { avatarHash, fullName, points } = this.props;
    const img = avatarHash ? (
      <img
        className="member__img"
        src={`https://trello-avatars.s3.amazonaws.com/${avatarHash}/30.png`}
      />
    ) : (
      <div className="member__placeholder" />
    );
    return (
      <div className="member">
        {img}
        <h3 className="member__name">{fullName}</h3>
        <Number className="member__points">{points}</Number>
      </div>
    );
  }
}

export default Member;



// WEBPACK FOOTER //
// ./src/Member.js